import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'pastFuturePipe',
})
export class PastFuturePipe implements PipeTransform {
  transform(value: Date, pastLabel: string, futureLabel: string): any {
    if (value) {
      const inputDate = new Date(value);
      inputDate.setHours(0, 0, 0, 0);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return inputDate >= today ? futureLabel : pastLabel;
    }
  }
}
